import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useForm, Controller } from "react-hook-form";
import { toast } from "react-toastify"; import _ from "lodash";

import {
  Form,
  Button,
  Icon,
  Divider,
  Dropdown,
  Checkbox,
  Confirm
} from "semantic-ui-react";

import * as QUESTIONNAIRE_ACTIONS from "../../../actions/questionaireActions";
import * as QNAIREBR_ACTIONS from "../../../actions/brQnaireActions";
import * as BRULE_ACTIONS from "../../../actions/businessRuleActions";

export function QuestionaireBRDetails(props) {
  const [state, setState] = useState({
    brQnaire: { ...props.brQnaire },
    isChanged: false,
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    control,
  } = useForm({
    mode: "all",
    reValidateMode: "onBlur",
  });

  useEffect(() => {
    props.fetchBRulesAction(props.qnaire.tenantId);
  }, []);

  const onSubmit = (data) => {

    const isQuestionnaireActive = props.qnaire.status == "active" || props.qnaire.status == "underReview";

    if (isQuestionnaireActive) {
      setState((state) => ({ ...state, showConfirmEditBRQnaire: true, data: data }));
    } else {
      let toCommit = state.brQnaire;

      if (!_.isEmpty(data.brule_name)) {

        const selectedBRule = bRulesList.filter((brule) => brule.key === data.brule_name).map((brule) => ({ text: brule.text }));

        if (!_.isEmpty(selectedBRule))
          toCommit.brName = selectedBRule[0].text;
      }

      setState((state) => ({ ...state, isChanged: false }));

      props.saveBRQnaireAction(toCommit, props.tenantId);
      if (_.isEmpty(props.onComplete)) {
        props.onComplete();
      }
    }
  };

  const confirmEditBRQnaire = () => {
    let contentMessage = "The questionnaire is currently active or under review. Editing any part of the questionnaire will result in its deactivation, requiring it to undergo the review process again.";

    return (
      <Confirm
        header='Warning:'
        content={contentMessage}
        open={state.showConfirmEditBRQnaire}
        onCancel={() => setState((state) => ({ ...state, showConfirmEditBRQnaire: false }))}
        onConfirm={() => {
          setState((state) => ({ ...state, showConfirmEditBRQnaire: false }));
          let toCommit = state.brQnaire;

          if (!_.isEmpty(state.data.brule_name)) {

            const selectedBRule = bRulesList.filter((brule) => brule.key === state.data.brule_name).map((brule) => ({ text: brule.text }));

            if (!_.isEmpty(selectedBRule))
              toCommit.brName = selectedBRule[0].text;
          }

          setState((state) => ({ ...state, isChanged: false }));
          props.deactiveQuestionaireAction(props.qnaire);
          props.saveBRQnaireAction(toCommit, props.tenantId);
          if (_.isEmpty(props.onComplete)) {
            props.onComplete();
          }
        }}
      />
    );
  }


  const bRulesList = _.orderBy(props.bRules
    .map((brRule) => ({
      key: brRule.id,
      text: brRule.bRule,
      value: brRule.id,
    })), ['text']);

  const bRuleDropdown = () => {
    var defaultValue = state.brQnaire.brNameId ? state.brQnaire.brNameId : "";

    return (
      <Controller
        name="brule_name"
        control={control}
        rules={{ required: true }}
        setValue={setValue}
        defaultValue={defaultValue}
        render={({ field, fieldState, formState }) => {
          return (
            <div>
              <Dropdown
                className={fieldState.invalid ? "invalid-input-field" : ""}
                {...field}
                placeholder="Select a Business Rule"
                fluid
                selection
                search
                options={bRulesList}
                value={state.brQnaire.brNameId}
                onChange={(e, { value }) => {
                  setState((state) => ({
                    ...state,
                    brQnaire: {
                      ...state.brQnaire,
                      brNameId: value,
                    },
                    isChanged: true,
                  }));
                  field.onChange(value);
                }}
              />
              {fieldState.invalid && (
                <p className="validation-error">* Select a Business Rule</p>
              )}
            </div>
          );
        }}
      />
    );
  };

  return (
    <Form
      size="small"
      onSubmit={handleSubmit(onSubmit)}
      style={{ paddingBottom: "20px" }}
    >
      {confirmEditBRQnaire()}
      <Form.Field>
        <label>Link to Business Rule</label>
        {bRuleDropdown()}
      </Form.Field>
      <Form.Field>
        <Checkbox
          toggle
          label="Scheduled"
          checked={!!state.brQnaire.brScheduled}
          onChange={() => {
            setState((prevState) => ({
              ...prevState,
              brQnaire: {
                ...prevState.brQnaire,
                brScheduled: !prevState.brQnaire.brScheduled,
              },
              isChanged: true,
            }));
          }}
        />
      </Form.Field>
      {state.brQnaire.brScheduled && (
        <>
          <Form.Field>
            <label>Delay Amount</label>
            <input
              type="number"
              name="delayAmount"
              placeholder="e.g., 2"
              min="1"
              value={state.brQnaire.delayAmount || ""}
              onChange={(e) => {
                setState((state) => ({
                  ...state,
                  brQnaire: {
                    ...state.brQnaire,
                    delayAmount: e.target.value,
                  },
                  isChanged: true,
                }));
              }}
            />
          </Form.Field>
          <Form.Field>
            <label>Delay Unit</label>
            <Dropdown
              placeholder="Select unit"
              fluid
              selection
              options={[
                // { key: 'minutes', text: 'Minutes', value: 'minutes' },
                { key: 'hours', text: 'Hours', value: 'hours' },
                { key: 'days', text: 'Days', value: 'days' },
                { key: 'weeks', text: 'Weeks', value: 'weeks' },
              ]}
              value={state.brQnaire.delayUnit}
              onChange={(e, { value }) => {
                setState((state) => ({
                  ...state,
                  brQnaire: {
                    ...state.brQnaire,
                    delayUnit: value,
                  },
                  isChanged: true,
                }));
              }}
            />
          </Form.Field>
        </>
      )}

      <Divider />
      <Button.Group floated="right">
        <Button
          className="danger"
          onClick={() => {
            if (_.isEmpty(props.onComplete)) {
              props.onComplete();
            }
          }}
        >
          <Icon name="remove" /> Cancel
        </Button>
        <Button type="submit" className="success" disabled={!state.isChanged}>
          <Icon name="checkmark" /> Ok
        </Button>
      </Button.Group>
    </Form>
  );
}

const mapStateToProps = (state, ownProps) => {
  var brQnaire = {};
  var isNew = false;
  var newBRQnaire = {
    qnairdId: '',
    brName: '',
    brNameId: '',
    brExecutionRule: '',
    brExecutionRuleVal: '',
    brAttrs: null,
  };

  if (ownProps.braction === 'add') {
    brQnaire = newBRQnaire;
    brQnaire.qnaireId = _.isEmpty(ownProps.qnaire) ? '' : ownProps.qnaire.id;
    isNew = true;
  } else {
    brQnaire = _.isEmpty(ownProps.brQnaire) ? newBRQnaire : ownProps.brQnaire;
    isNew = false;
  }

  return {
    brQnaire: brQnaire,
    isNew: isNew,
    brQnaires: (_.isEmpty(state.brQnaires)) ? [] : Object.values(state.brQnaires),
    bRules: (_.isEmpty(state.bRules)) ? [] : Object.values(state.bRules),
    tenantId: state.tenantManagement.activeTenant.tenantId
  };
};

export default connect(
  // map state to props
  mapStateToProps,
  // map dispatch to props
  (dispatch, ownProps) => ({
    fetchBRulesAction: (bRule) => dispatch(BRULE_ACTIONS.fetchbRulesAction(bRule)),
    deactiveQuestionaireAction: (questionaire) => dispatch(QUESTIONNAIRE_ACTIONS.deactiveQuestionaireAction(questionaire)),
    saveBRQnaireAction: (brQnaire, tenantId) => dispatch(QNAIREBR_ACTIONS.bRQnaireSaveAction(brQnaire, tenantId)),
  })
)(QuestionaireBRDetails);
